import { IDurationPeriods, IDurationUnits, IRequiredDurationValues } from '../interfaces';
import { RequiredTimeUnit, Period } from '../enums';
import { formatDigit } from './formatDigit';

const AVAILABLE_PERIODS = [
    Period.YEAR,
    Period.MONTH,
    Period.DAY,
    Period.HOUR,
    Period.MINUTE,
    Period.SECOND,
];

/**
 * Generate time string in "H:M:S" or "01h 02min 03s" format
 */
export const generateTimeString = (
    requiredDurationValues: IRequiredDurationValues,
    periods: IDurationPeriods,
    durationUnits: IDurationUnits,
    showDurationUnits = false,
): string => {
    const showUnits =
        showDurationUnits ||
        requiredDurationValues[Period.DAY] !== null ||
        requiredDurationValues[Period.MONTH] !== null ||
        requiredDurationValues[Period.YEAR] !== null;

    return AVAILABLE_PERIODS.reduce<string[]>((values, unit) => {
        if (
            requiredDurationValues[unit] !== null &&
            (periods[unit] > 0 || requiredDurationValues[unit] === RequiredTimeUnit.YES)
        ) {
            if (showUnits) {
                values.push(`${periods[unit]}${durationUnits[unit]}`);
            } else {
                values.push(formatDigit(periods[unit]));
            }
        }

        return values;
    }, []).join(showUnits ? ' ' : ':');
};
